import { useTranslation } from "react-i18next";

const QuestionMark = () => {
  const { i18n } = useTranslation();
  const logicChannel = sessionStorage.getItem("mylmx-logic");
  const currentLang = i18n.language || sessionStorage.getItem("mylmx-lang");
  const isFrance = currentLang === "fr" || logicChannel === "france";
  return (
    <span className="loginQuestionMark">
      <span className="loginQuestionIcon">?</span>
      <img
        className="loginQuestionImg"
        src={
          isFrance ? "images/MyLMX_Mouseover_fr.png" : "images/login_hover.jpg"
        }
      />
    </span>
  );
};

export default QuestionMark;
